import { NgModule } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { QuillModule } from 'ngx-quill';
import { LibSharedCommonModule } from '@solvace/common';
import { SvcQuillTextEditorComponent } from './svc-quill-text-editor.component';
import { SvcValidationMessageModule } from '@solvace/component/svc-validation-message';

@NgModule({
  imports: [
    LibSharedCommonModule,
    QuillModule,
    TranslocoModule,
    SvcValidationMessageModule,
  ],
  declarations: [SvcQuillTextEditorComponent],
  exports: [SvcQuillTextEditorComponent],
})
export class SvcQuillTextEditorModule {}
